<template>
  <div>
    <div style="margin-bottom: 10px" class="df both-side">
      <a-space>
        {{ route.query.projectName }}
        <a-select
          v-model:value="requestPayload.type"
          style="width: 120px"
          placeholder="审批"
          allowClear
          @change="handleSearch"
        >
          <a-select-option value="initiate">发起</a-select-option>
          <a-select-option value="approve">审批</a-select-option>
        </a-select>

        <a-select
          :options="projectLifeCycleOptions"
          v-model:value="requestPayload.projectLifeCycle"
          style="width: 200px"
          placeholder="项目阶段"
          @change="handleSearch"
          allowClear
        ></a-select>
        <a-input
          v-model:value="requestPayload.processName"
          placeholder="流程名称"
          @change="handleSearch"
          allowClear
        ></a-input>
      </a-space>
      <a-button @click="handleUpdateProject(null)">新增</a-button>
    </div>
    <a-table
      :data-source="currentTableData"
      bordered
      :pagination="false"
      :columns="columns"
      rowKey="id"
      class="table-space"
      :scroll="{ x: 'calc(100vw - 80px)', y: 'calc(100vh - 260px)' }"
    >
      <template #annex="{ record }">
        <a-button
          v-if="record.annex"
          @click="handleDownloadFile(record.annex)"
          type="primary"
          size="small"
          >下载</a-button
        >
      </template>
      <template #approved="{ record }">
        <a-tag v-if="record.approved === null" color="#108ee9">待审核</a-tag>
        <a-tag v-else-if="record.approved === false" color="#f50"
          >审核未通过</a-tag
        >
        <a-tag v-else-if="record.isEnd" color="#87d068">结束</a-tag>
      </template>
      <template #action="{ record }">
        <a-space>
          <a-dropdown :disabled="record.approver !== user.nickName">
            <template #overlay>
              <a-menu @click="handleToExamine($event, record)">
                <a-menu-item key="pass">审核通过</a-menu-item>
                <a-menu-item key="fail">审核不通过</a-menu-item>
              </a-menu>
            </template>
            <a-button size="small">
              审批
              <DownOutlined />
            </a-button>
          </a-dropdown>

          <a-button @click="handleUpdateProject(record)" size="small"
            >查看</a-button
          >

          <a-button
            type="danger"
            @click="handleDeleteRecord(record)"
            size="small"
            :disabled="record.promoter !== user.nickName"
            >删除</a-button
          >
        </a-space>
      </template></a-table
    >

    <div class="df both-side">
      <div></div>
      <a-pagination
        :total="table.data.length"
        :show-total="(total) => `共 ${total} 条`"
        :page-size="table.lineNum"
        v-model:current="table.pageNum"
        @change="handlePageChange"
      />
    </div>
  </div>

  <ena-form ref="enaFormRef" @updateTable="getData"></ena-form>

  <examine-form ref="examineFormRef" @updateTable="getData"></examine-form>
</template>

<script>
import { computed, defineComponent, inject, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { useTable } from "@/views/notice/serve/table";
import { DownOutlined } from "@ant-design/icons-vue";
import {
  deleteDesignChanges,
  getDesignChangesList,
} from "@/request/view/project";
import { download } from "@/views/rdmanagement/serve/index";
import enaForm from "@/views/rdmanagement/components/ena/form.vue";
import examineForm from "@/views/rdmanagement/components/ena/examine.vue";
import { debounce } from "@/utils";
import { projectLifeCycleOptions } from "@/views/rdmanagement/components/database/options";

export default defineComponent({
  components: { enaForm, examineForm, DownOutlined },
  setup() {
    const route = useRoute();
    const user = useStore().state.user.user;
    const enaFormRef = ref();
    const activeKey = inject("activeKey", null);
    const examineFormRef = ref();
    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
    } = useTable();

    initPayload({
      type: null,
      processName: null,
      projectLifeCycle: null,
      projectLifeCycleId: null,
      username: null,
    });

    table.lineNum = 10;

    const currentTableData = computed(() => {
      const startIndex = (table.pageNum - 1) * table.lineNum;
      const endIndex = table.pageNum * table.lineNum;
      return table.data.slice(startIndex, endIndex);
    });

    const columns = [
      {
        title: "设计变更内容",
        dataIndex: "processName",
        align: "center",
      },
      {
        title: "发起人",
        dataIndex: "promoter",
        align: "center",
      },
      {
        title: "审批阶段",
        dataIndex: "nodeName",
        align: "center",
      },
      {
        title: "审批状态",
        align: "center",
        slots: {
          customRender: "approved",
        },
      },
      {
        title: "审核意见",
        dataIndex: "notes",
        align: "center",
      },
      {
        title: "审批人",
        dataIndex: "approver",
        align: "center",
      },
      {
        title: "附件",
        slots: {
          customRender: "annex",
        },
        align: "center",
      },
      {
        title: "操作",
        slots: {
          customRender: "action",
        },
        align: "center",
      },
    ];

    requestConfig.pull_fn = getDesignChangesList;
    requestConfig.delete_fn = deleteDesignChanges;

    const handleUpdateProject = (record) => {
      const title = record ? "修改设计变更" : "添加设计变更";
      const type = record ? "update" : "insert";
      enaFormRef.value.showModal({
        title,
        data: record,
        type,
      });
    };

    const handleProjectDetails = (record) => {
      console.log(record);
    };

    const getData = () => {
      getListData({ unPagingRequest: true }).then((res) => {
        table.data.forEach((item) => {
          const approvedList = item.nodes.filter(
            (node) => node.approved === true
          );
          const currentExamine = item.nodes[approvedList.length];

          item.approver = currentExamine ? currentExamine.approver : "无";
          item.nodeName = currentExamine ? currentExamine.nodeName : "无";
          item.approved = currentExamine ? currentExamine.approved : "";
          item.notes = currentExamine ? currentExamine.notes : "";
        });
      });
    };

    const handleToExamine = (e, record) => {
      const type = e.key;

      const title = type === "pass" ? "审核通过" : "审核未通过";
      examineFormRef.value.showModal({
        title,
        type,
        record,
      });
    };

    const handleDeleteRecord = (record) => {
      deleteRecords([record.id], { title: "确定删除记录？" }).then((res) => {
        getData();
      });
    };

    if (route.query.processName && route.query.type === "link") {
      requestPayload.processName = route.query.processName;
    }

    const handlePageChange = (page, pageSize) => {
      table.pageNum = page;
    };

    const handleSearch = debounce(() => {
      getData();
    }, 200);

    const handleDownloadFile = (url) => {
      download(url, "下载");
    };

    watch(
      () => route,
      (val) => {
        if (route.path === "/rdprojectlayout") {
          requestPayload.projectLifeCycle = route.query.projectLifeCycle;
          requestPayload.projectLifeCycleId = route.query.projectId;
          getData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    watch(
      () => activeKey,
      (val) => {
        if (val && val.value === "设计变更") {
          getData();
        }
      },
      {
        deep: true,
      }
    );
    return {
      user,
      table,
      columns,
      route,
      requestPayload,
      enaFormRef,
      examineFormRef,
      currentTableData,
      projectLifeCycleOptions,
      handleDownloadFile,
      handlePageChange,
      handleSearch,
      getData,
      handleToExamine,
      handleProjectDetails,
      handleUpdateProject,
      handleDeleteRecord,
    };
  },
});
</script>

<style lang="less" scoped>
.table-space {
  margin: 10px 0;
}
</style>
